export const COOKIE_BETA_DASHBOARD_NAME = process.env.COOKIE_BETA_DASHBOARD_NAME
export const COOKIE_ROOT_DOMAIN = process.env.COOKIE_ROOT_DOMAIN

export * from "./AccountDropdown/AccountDropdown"
export * from "./LanguageSwitcher"
export * from "./LocalizationLoader"
export * from "./SupportDropdown"
